export function initCrisp(user) {
  if (!window.$crisp || !user) {
    return;
  }
  window.$crisp.push(["set", "user:email", [user.email]]);
  // user.stripeCustomerId &&
  //   window.$crisp.push([
  //     "set",
  //     "user:stripe_customer_id",
  //     [user.stripeCustomerId],
  //   ]);
  // user.stripeSubscriptionId &&
  //   window.$crisp.push([
  //     "set",
  //     "user:stripe_subscription_id",
  //     [user.stripeSubscriptionId],
  //   ]);
  window.$crisp.push([
    "set",
    "user:nickname",
    [`${user.firstName} ${user.lastName}`],
  ]);

  window.$crisp.push(["set", "session:segments", [[user.plan], true]]);
}

export const openCrispChat = () => {
  window.$crisp.push(["do", "chat:open"]);
};

export const closeCrispChat = () => {
  window.$crisp.push(["do", "chat:hide"]);
};
